export default __webpack_public_path__ + "static/media/791.fc85a233.png";